import PropTypes from 'prop-types';
import React from 'react';

import {
  GenderIcon,
  DateTimeFormat,
  Span,
  Icon,
  AgeFromDate
} from '@febos-io/design';
import { CensoredData } from '@febos-io/auth';

import { useTranslation } from '../hooks';

export function ModalPatientInformation({ company, patient, fromDate, }) {
  const { t, } = useTranslation();
  return (
    <div className="row mb-2">
      <div className="col-6">
        <div className="d-flex align-items-center gap-1">
          <div>
            <GenderIcon gender={patient.gender} fontSize="30" />
          </div>
          <div>
            <h6 className="mb-0">
              <strong className="d-inline fs-6 text-gray">{t('Patient')}</strong>
            </h6>
            <span className="fs-4 text-truncate">
              (
              <CensoredData companyId={company}>{patient.identificationNumber}</CensoredData>
              )
              {' '}
              <CensoredData>
                {patient.name}
                {' '}
                {patient.lastName}
              </CensoredData>
            </span>
          </div>
        </div>
      </div>
      <div className="col-4">
        <div className="d-flex align-items-center gap-1">
          <div>
            <Icon icon="calendar" fontSize="30" iconLibrary="far" />
          </div>
          <div>
            <h6 className="mb-0">
              <strong className="d-inline fs-6 text-gray">{t('Birth Date')}</strong>
            </h6>
            <CensoredData>
              <DateTimeFormat
                value={patient.birthDate}
                format="dd-MM-yyyy"
                className="fs-4 text-truncate"
              />
            </CensoredData>
          </div>
        </div>
      </div>
      {patient.email && (
        <div className="col-4">
          <div className="d-flex align-items-center gap-1">
            <div>
              <Icon icon="at" fontSize="30" iconLibrary="far" />
            </div>
            <div>
              <h6 className="mb-0">
                <strong className="d-inline fs-6 text-gray">{t('Email')}</strong>
              </h6>
              <CensoredData>{patient.email}</CensoredData>
            </div>
          </div>
        </div>
      )}
      {patient.birthDate && (
        <div className="col">
          <div className="d-flex align-items-center gap-1">
            <div>
              <Icon icon="cake-candles" fontSize="30" iconLibrary="far" />
            </div>
            <div className="text-center">
              <Span
                title={(
                  <>
                    {t('Age')}
                    :
                    <AgeFromDate value={patient.birthDate} isIso />
                    {' '}
                    {t('Years')}
                  </>
                )}
                className="fs-4"
              >
                <h6 className="mb-0">
                  <strong className="d-inline fs-6 text-gray">{t('Age')}</strong>
                </h6>
                <AgeFromDate
                  value={patient.birthDate}
                  isIso
                  className="fs-4 text-truncate"
                  fromDate={fromDate}
                />
              </Span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ModalPatientInformation;

ModalPatientInformation.propTypes = {
  patient: PropTypes.object.isRequired,
  fromDate: PropTypes.string,
  company: PropTypes.string,
};
